import { CourseDto } from "../../../../models/courseDto";
import styles from "./course.module.scss";
import { default as Swal, default as SweetAlert } from "sweetalert2";
import { TypeCourse } from "../../../../models/typeCourseDto";
import { translate } from "react-switch-lang";

const CoursesTable: React.FC<{ course: CourseDto; getCourseTimeString: any; handleUpdate: any; deleteCourse: any; handleClickOpenModalViewer: any; getStepIcon: any; disabled?: boolean,t: (key: string) => string }> = ({
  course,
  getCourseTimeString,
  handleUpdate,
  deleteCourse,
  getStepIcon,
  handleClickOpenModalViewer,
  disabled,
  t
}) => {
  return (
    <tr>
      <th>{course.title}</th>
      <td className={styles["center_content"]}>{getCourseTimeString(course.courseHours, course.courseMinutes)}</td>
      <td className={styles["center_content"]}>{getStepIcon(TypeCourse[course.courseType])}</td>
      <td className={styles["center_content"]}>
        <span>{!disabled && <i onClick={() => handleUpdate(course)} title="Modifier les informations du cours" className="fa fa-edit" id={styles["course__actions__btn"]}></i>}</span>
        <span>
          {!disabled && (
            <i
              title="Suprimer le cours"
              onClick={() => {
                SweetAlert.fire({
                  title: "Êtes-vous sûr que vous voulez supprimer ce cours?",
                  cancelButtonText: t("cancel"),
                  confirmButtonText: "Supprimer !",
                  confirmButtonColor: "#FF0000",
                  reverseButtons: true,
                  showCancelButton: true,
                  icon: "warning",
                }).then(result => {
                  if (result.isConfirmed) {
                    deleteCourse(course.id);
                    Swal.fire("Cours Bien Supprimé!", "", "success");
                  }
                });
              }}
              className={"fa fa-trash-o"}
              id={styles["course__actions__btn"]}
            ></i>
          )}
        </span>
        <span>
          <i title="Visualiser le support du cours" className="icon-eye" id={styles["course__actions__btn"]} onClick={() => handleClickOpenModalViewer(course)}></i>
        </span>
      </td>
    </tr>
  );
};

export default translate(CoursesTable) ;
